export const testimonials = [
  {
    author: 'Dr. Akankwasa Barirega',
    title: 'Executive Director',
    organization: "Uganda's National Environmental Management Authority (NEMA)",
    quote: "The Sustainability and Climate Finance Centre is a significant milestone in Uganda's journey towards resilience and environmental sustainability.",
    image: '/images/Dr-Akankwasa-photo.jpg'
  },
  {
    author: 'Dr. Joanes Atela',
    title: 'Director',
    organization: 'Research Impact Network',
    quote: "Climate change is a main challenge to the African continent. The Sustainability and Climate Finance Centre is a critical step towards building the capacity and expertise needed to drive climate action at all levels of society.",
    image: '/images/Dr-Joanes-Atela-Photo.jpg'
  },
  {
    author: 'Professor Moses Muhwezi',
    title: 'Principal',
    organization: 'Makerere University Business School',
    quote: "The Sustainability and Climate Finance Centre is a testament to our commitment to addressing the climate crisis at its roots – by educating the next generation. It is a call to action for governments, businesses, and individuals to invest in education as a powerful tool to combat climate change.",
    image: '/images/Prof-Moses-Muhwezi-Photo.jpg'
  },
  {
    author: 'Dr. Christine Grüning',
    title: 'Director',
    organization: 'Frankfurt School – UNEP Collaborating Centre',
    quote: "We are proud to be a partner in this groundbreaking initiative. By providing knowledge and skills to navigate the complex world of climate and sustainable finance, we are sowing the seeds of a greener, more resilient future.",
    image: '/images/Dr-Christine.jpg'
  }
];